import { useQuery } from '@tanstack/react-query';
import { bffApiClient } from './client';

export type EquipmentCatalogViewModel = {
  id: string;
  name: string;
  version: number;
  modelsJson: string;
  functionsJson: string;
  firmwareCommand: string;
  sourceProcedureName: string | null;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
};

const EQUIPMENT_CATALOGS_QUERY_KEY = 'equipmentCatalogs';

export const useEquipmentCatalogsQuery = (enabled = true) => {
  return useQuery<EquipmentCatalogViewModel[], Error>({
    queryKey: [EQUIPMENT_CATALOGS_QUERY_KEY, 'list'],
    queryFn: async () => {
      const response = await bffApiClient.get<EquipmentCatalogViewModel[]>(
        '/api/equipment-catalogs'
      );
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  });
};

export const useEquipmentCatalogQuery = (id: string | null, enabled = true) => {
  return useQuery<EquipmentCatalogViewModel, Error>({
    queryKey: [EQUIPMENT_CATALOGS_QUERY_KEY, 'byId', id],
    queryFn: async () => {
      const response = await bffApiClient.get<EquipmentCatalogViewModel>(
        `/api/equipment-catalogs/${id}`
      );
      return response.data;
    },
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  });
};
